<template>
  <div>
    <h1>
       <span v-if="firstName">{{ firstName }}, </span> Thanks for your donation.
    </h1>
    <div class="sub-text">
      <p>Thank you <span v-if="firstName">{{ firstName }} </span
      ><span v-if="lastName">{{ lastName }}</span> for your
      <span v-if="frequency">{{ frequency }}</span> gift
      <span v-if="amount">
        of <span class="amount">$ {{ amount }}</span></span
      ></p>
    </div>
  </div>
</template>

<script>
import { getParameterByName } from "../helpers";

export default {
  name: "ThankYouDonation",
  data: function () {
    return {
      firstName: null,
      lastName: null,
      frequency: null,
      amount: null,
    };
  },
  created: function () {
    let q = getParameterByName("q");
    if (q) {
      let decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = getParameterByName("firstname", decodeq);
      this.lastName = getParameterByName("lastname", decodeq);
      this.frequency = getParameterByName("frequency", decodeq);
      this.amount = getParameterByName("amount", decodeq);

      console.log("firstname", this.firstName);
    }
  },
};
</script>

<style scoped>

.amount {
  white-space: nowrap;
}

.sub-text {
  padding-top: 2rem;
}

.sub-text p {
  font-size: 20px;
}

</style>


// WEBPACK FOOTER //
// ThankYouDonation.vue?3177c2bc